/** @jsxImportSource @emotion/react */

import { useContext, useEffect, useState } from "react";
import tw from "twin.macro";
import { Card, CardHeader } from "../components/Card";
import { Field } from "../components/Field";
import { Page } from "../components/Page";

import { UserContext } from "context/UserContext";
import { User } from "services/User.d";

const Profile = () => {
  const [currentUser, setcurrentUser] = useState<User>({
    username: "",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    st: "",
    zip: "",
  });

  const { user, isLoggedIn } = useContext(UserContext);

  useEffect(() => {
    if (user) {
      setcurrentUser({
        ...currentUser,
        firstname: user?.firstname,
        lastname: user?.lastname,
        email: user?.email,
        phone: user?.phone,
        address: user?.address,
        city: user?.city,
        st: user?.st,
        zip: user?.zip,
      });
    }
  }, [user]);

  return (
    <>
      <Page title="Profile" label="Profile">
        <Card css={[tw`drop-shadow-sm rounded-md border border-gray-200`]}>
          <CardHeader>
            <h4>Personal Information</h4>
          </CardHeader>

          <div
            css={[
              tw`grid gap-y-4 grid-cols-2 justify-items-stretch md:w-1/2 w-full`,
            ]}
          >
            <Field label="First Name" text={currentUser.firstname} />
            <Field label="Last Name" text={currentUser.lastname} />
            <Field label="Phone Number" text={currentUser.phone} />
            <Field
              label="Address"
              text={[
                currentUser.address,
                currentUser.city,
                currentUser.st,
                currentUser.zip,
              ]
                .filter(Boolean)
                .join(", ")}
            />
            <Field
              wrapperCss={[tw`col-span-2 md:col-span-1`]}
              label="Email Address"
              text={currentUser.email}
            />
          </div>
        </Card>
      </Page>
    </>
  );
};

export default Profile;
